const messages = {
    fr: {
        gammes: {
            solutions_title: 'Les solutions de <span class="accroche-green">notre gamme</span>',

            health: {
                title: 'Gamme <span class="accroche-green">santé</span>',
                subtext: 'Datacenters, cloud et services numériques certifiés HDS.',
                preshot: 'Hébergez et protégez les données issues du parcours santé et bien-être de vos patients ou clients, dans des datacenters certifiés HDS et cybersécurisés.',
                solutions: {
                    title: 'Les solutions de <span class="accroche-green">notre gamme</span>',
                    hds: {
                        title: 'Votre hébergement souverain, certifié HDS',
                        listing: '      <ul>\n' +
                            '        <li>Vous êtes hébergés dans un datacenter situé en France, tolérant aux pannes, et intégralement redondé au\n' +
                            '          niveau\n' +
                            '          de ses alimentations.\n' +
                            '        </li>\n' +
                            '        <li>Dédié depuis sa mise en service à l\'hébergement de services essentiels et notamment de services de mutuelles\n' +
                            '          et\n' +
                            '          assureurs-santé, ce datacenter est particulièrement adapté aux impératifs de protection de votre secteur\n' +
                            '          d’activité.\n' +
                            '        </li>\n' +
                            '        <li>Les environnements d’hébergement du datacenter sont certifiés ISO 27001 : 2013 et Hébergeur de Données de\n' +
                            '          Santé\n' +
                            '          -hébergeur d’infrastructure physique.\n' +
                            '        </li>\n' +
                            '      </ul>'
                    },
                    cybersecurity: {
                        title: 'Cyberdéfense de vos services de santé hébergés',
                        subtext: 'Rançongiciels, menaces de sabotage contre des infrastructures hospitalières… votre secteur est\n' +
                            '        fréquemment la cible d’attaques informatiques qui menacent la confidentialité, l’intégrité et la disponibilité\n' +
                            '        des données.',
                        listing: '      <ul>\n' +
                            '        <li>C’est la raison pour laquelle nous avons choisi d’adosser à nos datacenters un Centre de Cyberdéfense (SOC),\n' +
                            '          opéré par nos équipes.\n' +
                            '        </li>\n' +
                            '        <li>Ce centre permet d\'assurer une surveillance de votre infrastructure, et vous accompagne dans le traitement de vos incidents de cybersécurité, depuis la détection jusqu\'à l\'accompagnement à la remédiation.' +
                            '        </li>\n' +
                            '      </ul>'
                    },
                    hosting: {
                        title: 'Hébergeur de données de santé certifié',
                        subtext: 'Les infrastructures d’hébergement physique de La Citadelle Datacenter sont certifiées pour\n' +
                            '        héberger des données de santé. Cette certification est un engagement de fiabilité pour les acteurs des secteurs\n' +
                            '        du bien-être et du médical.'
                    }
                }

            },
            finance: {
                title: 'Gamme <span class="accroche-green">finance</span>',
                subtext: 'Sécurité et hébergement pour le e-commerce et les services monétiques.',
                preshot: 'Qu’il s’agisse des données financières de vos clients, ou de vos propres données de gouvernance, ces informations sont hautement stratégiques pour votre activité et méritent une protection adéquate.',
                solutions: {
                    title: 'Les solutions de <span class="accroche-green">notre gamme</span>',
                    pci: {
                        title: 'Un hébergement informatique certifié ISO 27001',
                        subtext: 'Dans le contexte actuel où les achats en ligne et démarches en distanciel se multiplient, vous ne pouvez souffrir d\'aucune perte de disponibilité ou d\'une atteinte à la confidentialité sur vos services :',
                        listing: '<ul>' +
                            '        <li>La Citadelle met à votre disposition un datacenter au taux de disponibilité avéré de 100% (depuis sa mise en service en 2014) : conçu comme s\'il se' +
                            '          trouvait en plein désert, sa conception a été pensée en fonction des contraintes de ce type d\'environnement et' +
                            '          toute dépendance à des fournisseurs extérieurs supprimée.' +
                            '' +
                            '        </li>' +
                            '        <li>Ce datacenter est certifié ISO 27001 pour apporter à ses clients hébergés une garantie de sécurité.' +
                            '        </li>' +
                            '      </ul>'
                    },
                    cybersecurity: {
                        title: 'La supervision de vos évènements de cybersécurité',
                        subtext: 'Les domaines de la banque, de l’assurance et du commerce sont des domaines très réglementés, et qui sont fréquemment la cible de cyberattaques.',
                        posttext: 'Notre centre de cyberdéfense (SOC - Security Operations Center) vous accompagne dans le traitement de vos incidents de cybersécurité, depuis la détection jusqu\'à l\'accompagnement à la remédiation.'
                    },
                },

            },
            souverainete: {
                title: 'Gamme <span class="accroche-green">souveraineté</span>',
                subtext: 'Datacenters, cloud et centre de cyberdéfense souverains.',
                preshot: 'Protégez vos systèmes d\'information les plus critiques dans des environnements d\'hébergement situés en France, hautement sécurisés et conformes aux plus hauts standards de sécurité avec un service de cyberdéfense associé.',
                solutions: {
                    title: 'Les solutions de <span class="accroche-green">notre gamme</span>',
                    sovereign: {
                        title: 'Un hébergement souverain',
                        subtext: 'Vous accédez à un datacenter situé en France, dont la sécurité et le maintien en conditions opérationnelles sont gérés par nos propres équipes.',
                        listing: '<ul>\n' +
                            '        <li>Les environnements d\'hébergement du datacenter sont certifiés ISO 27001:2013, HDS et sont conformes\n' +
                            '          à\n' +
                            '          l\'IGI 1300 pour les mesures de protection physique des informations classifiées de défense, jusqu\'au niveau\n' +
                            '          Secret Défense inclus.\n' +
                            '        </li>\n' +
                            '        <li>Le datacenter dispose de solutions d\'hébergement privatif en cage de Faraday, pour les systèmes\n' +
                            '          d\'information\n' +
                            '          les plus critiques qui nécessitent des protections contre le rayonnement électrique et électromagnétique ; et\n' +
                            '          contre le risque d\'interception.\n' +
                            '        </li>\n' +
                            '      </ul>',
                        posttext: 'En raison de sa conception unique et de son très haut niveau de service, notre datacenter peut\n' +
                            '        être votre solution adéquate pour un site de repli hautement sécurisé. En effet, <b>La Citadelle Datacenter est\n' +
                            '          intégralement tolérant aux pannes</b> : l\'ensemble de ses alimentations électriques, de refroidissement et de\n' +
                            '        télécommunications est\n' +
                            '        à <i>minima</i> redondé. Il présente ainsi <b>100% de disponibilité avérée depuis sa mise en service, en\n' +
                            '          2014</b>.'
                    },
                    cybersecurity: {
                        title: 'Cyberdéfense de vos services hébergés',
                        subtext: 'Le datacenter est adossé à un Centre de Cyberdéfense (SOC), opéré par nos équipes au sein de nos locaux.',
                        posttext: 'Ce centre permet d\'assurer une surveillance de votre infrastructure, et vous accompagne dans le traitement de vos incidents de cybersécurité, depuis la détection jusqu\'à l\'accompagnement à la remédiation.'
                    },
                    cloud: {
                        title: 'Cloud Souverain',
                        subtext: 'La souveraineté des données stockées dans Cloud constitue un des sujets de préoccupation majeur des entreprises françaises et européennes. La Citadelle garantit à ses clients que leur hébergement et l\'ensemble des traitements associés sont réalisés en France.',
                        listing: '<ol>\n' +
                            '        <li>BeYs Cloud France, l\'entreprise propriétaire des datacenters de la Citadelle, est une entreprise de droit français.</li>\n' +
                            '        <li>L\'ensemble des opérations autour des datacenters est assuré par ses propres équipes sur nos sites français.</li>\n' +
                            '        <li>L\'ensemble des services délivrés à ses clients le sont par ses propres équipes et de prestataires de confiance, localisés en France et en mesure d\'appliquer les mêmes exigences.</li>\n' +
                            '      </ol>',
                    },
                    certified: {
                        title: 'Un service certifié',
                        subtext: 'Les infrastructures d\'hébergement physique du datacenter et la cybersurveillance associée sont certifiées ISO/IEC 27001:2013.',
                        posttext: 'Cela signifie que nous disposons d\'un système de management interne relatif à la sécurité de l\'information, et que vous bénéficiez de cette gestion rigoureuse pour la sécurité et la confidentialité de vos données.'
                    }

                }
            },
            innovation: {
                title: 'Gamme <span class="accroche-green">innovation</span>',
                subtext: 'Protection des savoir-faire innovants.',
                preshot: 'Cet ensemble de solutions “tout-en-un” vous permet d’héberger, sauvegarder, connecter et sécuriser vos outils de travail et vos innovations, le tout avec des solutions créées et déployées par des entreprises françaises et de proximité.',
                solutions: {
                    title: 'Les solutions de <span class="accroche-green">notre gamme</span>',
                    proximity: {
                        title: 'Un hébergement dans un datacenter de proximité',
                        subtext: 'La Citadelle est un datacenter de confiance et de proximité, opéré intégralement par nos équipes. Le tout, à Clermont-Ferrand, en Auvergne, en plein cœur de la France. Pour héberger votre site web, vos outils collaboratifs, ou les applications que vous développez, vous choisissez :',
                        listing: '<ul>' +
                            '        <li>' +
                            '          soit une formule en hébergement physique : nous vous mettons à disposition un emplacement physique dans une' +
                            '          baie informatique pour vos équipements ;' +
                            '        </li>' +
                            '        <li> soit l\'hébergement cloud : nous mettons à disposition des machines virtuelles sur une infrastructure' +
                            '          matérielle pré-installée dans notre datacenter.' +
                            '        </li>' +
                            '      </ul>'
                    },
                    connectivity: {
                        title: 'Des services de connectivité haut-de-gamme',
                        subtext: 'Parce que votre métier dépend étroitement d’une haute connectivité et d’une haute résilience, La Citadelle vous propose une offre d\'accès internet haut-de-gamme. Nous sommes en mesure de déployer des liaisons s’affranchissant des limites de débit.',
                        listing: '<ul>' +
                            '        <li>La Citadelle Datacenter dispose de son propre système autonome (Autonomous System) qui lui permet de mettre' +
                            '          à votre disposition des classes d\'adresses IPv4 et IPv6.' +
                            '        </li>' +
                            '        <li>Un routeur est compris dans notre formule, qui dispose des fonctionnalités de pare-feu (firewall). Vous' +
                            '          disposez également de la téléphonie avec la possibilité d’effectuer quatre communications simultanées' +
                            '          sortantes vers des fixes comme des mobiles.' +
                            '        </li>' +
                            '      </ul>'
                    }
                }
            }
        },
        datacenter: {
            title: 'Présentation de <span class="accroche-green">nos datacenters</span>',
            subtext: 'La Citadelle est l\'unique centre d\'hébergement souverain et cyber-sécurisé qui assure la continuité de vos services, en toutes circonstances.',
            preshot: 'La Citadelle est construite autour de <b>deux centres de traitement des données (datacenters)</b> adossées à un <b>centre de cyberdéfense</b>. Au coeur du territoire français, elle se situe au carrefour des réseaux de télécommunications et d\'approvisionnement, pour une disponibilité et un niveau de service maximal.',
            choose_la_citadelle: {
                title: 'Six raisons de <span class="accroche-green">choisir La Citadelle</span>',
                sovereign: {
                    title: 'Souveraineté',
                    content: 'Le maintien en conditions opérationnelles, ainsi que l\'ensemble des opérations sont réalisés par nos équipes en France.',
                },
                connectivity: {
                    title: 'Connectée & Résiliente',
                    content: 'La Citadelle est desservie par deux chemins totalement indépendants de fibre arrivant au sein de nos deux locaux télécom (Meet-Me-Rooms), distincts et redondés entre eux.',
                },
                security: {
                    title: 'Sécurité en profondeur',
                    content: 'Le dispositif de sécurité de La Citadelle est constitué d\'un ensemble de mesures de protection physiques, logiques et électroniques.',
                },
                flexibility: {
                    title: 'Flexibilité',
                    content: 'La disponibilité et la sécurité des cinq salles d\'hébergement se renforcent pour s\'adapter à la sensibilité de la donnée hébergée et traitée.',
                },
                evolutivity: {
                    title: 'Évolutivité',
                    content: 'La conception de La Citadelle nous permet de faire évoluer votre offre en même temps que votre activité et vos besoins métiers. Pour chacun de vos besoins, nous aurons une solution adaptée à vous.',
                },
                cybersecurity: {
                    title: 'Cybersécurité',
                    content: 'La Citadelle est le seul datacenter français a être directement adossé à un centre de cyberdéfense qui supervise les évènements de cybersécurité des équipements hébergés, et intervient en cas d\'incident.',
                },
            },
            meet_our_datacenters: 'Découvrez en détails <span class="accroche-green">nos deux datacenters</span>',
            connectivity: 'Opérateurs et <span class="accroche-green">connectivité</span>',
            connectivity_content: '<p>La Citadelle dispose de deux locaux télécoms (ou Meet-Me-Rooms) redondés entre eux et qui héritent du très' +
                '          haut niveau de sécurité du site physique.</p>' +
                '        <ul>' +
                '          <li>Chaque local dispose de son propre chemin de livraison de fibre, ces chemins étant physiquement et' +
                '            géographiquement séparés depuis des chambres de tirage distinctes sur le domaine public.' +
                '          </li>' +
                '          <ul>' +
                '            <li>Opérateurs déjà présents dans les MMR : ABEILLE, ADISTA, COVAGE, LIOPEN, ORANGE, SFR.</li>' +
                '            <li>Autres raccordements possibles.' +
                '            </li>' +
                '          </ul>' +
                '        </ul>' +
                '        <ul>' +
                '          <li>La Citadelle est membre du GIX AuvernIX, qui permet l’amélioration de l’interconnexion des opérateurs de' +
                '            télécommunication (peering) en Auvergne et dans le Massif Central.' +
                '          </li>' +
                '          <li>La Citadelle a son propre AS (Autonomous System) et peut ainsi distribuer des classes d\'adresses IPv4 et' +
                '            IPv6.' +
                '          </li>' +
                '        </ul>'
        },
        hosting: {
            main_title: 'Un hébergement <span class="accroche-green">hautement sécurisé, et résilient</span>',
            subtext: 'Choisissez pour vos données et vos services des datacenters de confiance, hautement disponibles et à très haut niveau de sécurité.',
            preshot: 'Les deux datacenters de La Citadelle disposent de cinq environnements d\'hébergements aux niveaux de sécurité et de disponibilité croissants. Avec cette flexibilité, ce sont nos salles qui s\'adaptent au niveau de protection que vous souhaitez offrir à vos services.',
            cards: {
                mmr: {
                    title: 'Meet-Me-Rooms',
                    content: 'Demi-baies dédiées, avec contrôle d\'accès dans deux locaux opérateurs distincts et redondés.',
                },
                mutualisation: {
                    title: 'Hébergement mutualisé',
                    content: 'Disponible dans les deux datacenters et les cinq salles d\'hébergement de La Citadelle.',
                },
                dedicated: {
                    title: 'Hébergement dédié',
                    content: 'Demi-baies (20U) et baies entières (42U) disponibles dans les deux datacenters. Cages privatives disponibles dans le second datacenter (DC2).'
                }
            },
            services_title: 'Une panoplie de services, <span class="accroche-green">pour répondre à tous vos besoins</span>',
            neutrality_title: 'Un hébergeur, <span class="accroche-green">neutre et certifié</span>',
            certifications_pretext: 'La Citadelle Datacenter est certifiée :',
            equipment_neutrality: 'Tous nos équipements sont conçus et configurés de sorte à ne pas écouter ou altérer vos communications et données. La neutralité de l\'ensemble nos équipements actifs et passifs vous est garanti.',
            national_security: 'En outre, nous disposons de salles informatiques conformes aux référentiels de protection des informations relevant du secret de la défense nationale.'
        },
        landing: {
            stats: {
                datacenters: {
                    value: '2',
                    name: 'Centres de données',
                },
                security_levels: {
                    value: '5',
                    name: 'Niveaux de sécurité',
                },
                availability: {
                    value: '100%',
                    name: 'Disponibilité depuis 2014',
                },
                autonomy: {
                    value: '6 jours',
                    name: 'Autonomie électrique',
                },
                redundancy: {
                    value: '2N',
                    name: 'Redondance environnementale',
                }
            }
        },
        contact: {
            title: 'Contacter les équipes <span class="accroche-green">de La Citadelle</span>',
            subtext: 'Vous souhaitez visiter la Citadelle Datacenter, devenir client ou simplement échanger sur nos offres ? Contactez les équipes de BeYs Cloud France :',
            finalText: 'Nous nous tenons à votre disposition pour tout renseignement sur notre offre d\'hébergement souverain au sein de nos datacenters, et nos offres Cloud.'
        },
        404: {
            title: 'Oops, visiblement, c\'est <span class="accroche-green">une erreur 404</span>',
            subtext: 'Vous venez de trouver la seule chose qui peut casser au sein de La Citadelle Datacenter !',
            button: 'Et si nous retournions à l\'accueil ?️'
        },
        topMenu: {
            altLogo: "Logo de La Citadelle Datacenter",
            home: "Accueil",
            datacenter: "La Citadelle",
            hosting: "Hébergement",
            contact: "Contact"
        },
        footer: {
            altLogo: "Logo de La Citadelle Datacenter",
            legal: "Mentions légales"
        },
        general: {
            address: "BeYs Cloud France<br />46, rue du ressort<br />63000 Clermont-Ferrand<br />FRANCE",
            phone: "+33(0)4 73 74 58 90",
            email: "contact@be-ys.com"
        },
        generics: {
            certifications: '<ul>' +
                '<li>ISO 27001 (Système de management de la sécurité de l\'information)</li>' +
                '<li>HDS (Hébergeur de données de santé) - Couches 1 à 6</li>' +
                '</ul>',
            optional: "en option",
            discover_button: "Découvrir notre gamme {name}"
        },
        landing_components: {
            welcome: {
                more_details: "Découvrez en détails La Citadelle",
                title: 'Bienvenue au coeur de <span class="accroche-green">La Citadelle Datacenter</span>',
                subtext: 'Conçue et opérée par nos équipes en France, La Citadelle offre un environnement de confiance, hautement disponible et à très haut niveau de sécurité.',
                content: '<p>Située au centre de la France, La Citadelle est dédiée à la sécurisation et à l\'hébergement de votre' +
                    '          patrimoine numérique. Nous proposons une gamme de produit alliant un haut niveau de disponibilité, ainsi qu\'une' +
                    '          confidentialité et une intégrité maximale.<br/><br/>Opéré par BeYs, entreprise ayant 20 ans d\'expertise dans la' +
                    '          gestion du patrimoine et d\'identité numérique, vous faites le choix d\'un acteur souverain, et sans parti-pris' +
                    '          avec des organisations ou gouvernements étrangers.<br/>Nos engagements sont continuellement vérifiés par des organismes de certifications indépendants et par nos équipes internes. A ce titre, La Citadelle Datacenter dispose des certifications :</p>' +
                    '        {certifs}' +
                    '        <p>Disposant de deux datacenters, cinq salles d\'hébergement et d\'un centre de cyberdéfense, La Citadelle offre des prestations de sécurité et d\'hébergement hautement sécurisées, et vous ouvre l\'accès à l\'ensemble des solutions BeYs, marque spécialisée dans l\'identité numérique, les flux d\'informations personnelles et le traitement des données sensibles.</p>'
            },
            hosting_services: {
                physical: {
                    title: "Sécurité physique",
                    content: 'Au sein de La Citadelle, vous disposez d\'un site hautement sécurisé, gardienné, télésurveillé et vidéo-surveillé en permanence. Par ailleurs, les services essentiels des datacenters sont supervisés, 24h/24, 365j/365.'
                },
                utilities: {
                    title: "Fourniture des utilités et ressources",
                    content: 'Notre premier datacenter offre une redondance électrique classique avec onduleurs, et des systèmes frigorifiques en redondance N+1. Le deuxième datacenter offre une redondance totale (2N) des alimentations électriques et frigorifiques.'
                },
                connectivity: {
                    title: 'Liaisons Télécom',
                    content: 'Dans chaque datacenter, vous avez la possibilité de déployer une interconnexion télécom entièrement personnalisée.'
                },
                networking: {
                    title: 'Connectivité haut-débit',
                    content: 'Nous proposons un accès internet haut de gamme, avec possibilité de fournir des classes d\'adresses IPv4 et IPv6 à la demande. Nous pouvons également fournir des équipements de protection réseaux, notamment des firewalls.'
                },
                cybersecurity: {
                    title: "Centre de Cyberdéfense",
                    content: 'La Citadelle Datacenter propose un service unique sur le marché associant votre hébergement à la cyberdéfense de vos systèmes d\'information'
                },
                beys: {
                    title: 'Écosystème BeYs',
                    content: 'La Citadelle fait partie de l\'écosystème du groupe BeYs, mandataire de confiance numérique. En choisissant l\'hébergement au sein de la Citadelle, vous aurez accès à l\'ensemble des solutions opérées et hébergés dans ses datacenters'
                }

            },

            video: {
                main: 'CONFIDENTIALITÉ - SÉCURITÉ - SOUVERAINETÉ',
                secondary: 'AUCUN COMPROMIS'
            },
            offers: {
                title: 'Des solutions adaptées <span class="accroche-green">à tous vos coeurs de métiers</span>',
                sovereign: {
                    title: 'Souveraineté',
                    content: 'Pour les services essentiels, un hébergement à très haute disponibilité et sécurisé dans nos datacenters souverains, associés à notre centre de cyberdéfense et nos services Cloud.',
                },
                health: {
                    title: 'Santé',
                    content: 'Pour les acteurs traitant des données de santé, un hébergement certifié HDS, souverain, et des solutions de cybersécurité opérées par des experts du secteur santé.'
                },
                finance: {
                    title: 'Finance',
                    content: 'Pour les fintech et les acteurs du e-commerce, un hébergement ISO 27001, des offres de connectivité hautement résilientes, et de la cybersécurité pour vos applications monétiques.'
                },
                innovation: {
                    title: 'Innovation',
                    content: 'Pour les start-ups et TPE, un pack tout-en-un avec un hébergement de proximité, de la connectivité très haut débit, et des prestations de cybersécurité pour sécuriser les savoir-faire.'
                }
            },
            services_center: {
                title: 'La Citadelle, votre <span class="accroche-green">centre de services numériques</span>',
                cards: {
                    hosting: {
                        content: 'Louez des espaces d\'hébergement mutualisés, dédiés ou en cage privative au sein de nos datacenters ' +
                            'de confiance au taux avéré de 100% de disponibilité.',
                        title: 'Hébergement en colocation'
                    },
                    connectivity: {
                        content: 'Hébergez vos équipements réseaux dans nos Meet-me-Rooms ' +
                            'hautement sécurisées et neutres. Raccordé aux principaux opérateurs nationaux, nos MMR sont le lieu idéal pour vos interconnexions.',
                        title: 'Opérateurs et connectivité'
                    },
                    cloud: {
                        content: 'Découvrez notre offre BeYs Cloud, offrant une infrastructure de cloud-computing complète, souveraine et bénéficiant de l\'ensemble des services et de la sécurité de La Citadelle.',
                        title: 'IaaS et Cloud Souverain'
                    }
                }
            },
            expertises: {
                alt_img: {
                    iso27001: 'La Citadelle Datacenter est certifiée ISO27001.',
                    hds: 'La Citadelle Datacenter est certifiée HDS couches 1-6.'
                },
                title: 'Notre expertise <span class="accroche-green">à votre service</span>',
                subtitle: 'Fort de vingt années à vos côtés, nous sommes en mesure de répondre à tous vos besoins, même les plus exigeants.',
                certifications: {
                    title: 'Certifications',
                    content: '<p>La Citadelle Datacenter est certifiée : </p>' +
                        '        {certifs}' +
                        '        <p>En outre, nous disposons de salles informatiques conformes aux référentiels de protection des informations relevant du secret de la défense nationale.</p>'
                },

                knowledge: {
                    title: "Savoir-faire",
                    content: ' <p>Nos équipes portent une approche globale de la sécurité de l\'information, avec des savoir-faire en matière de sécurité des datacenters,' +
                        '          de cybersécurité, de sûreté bâtimentaire, de sûreté de fonctionnement et de sûreté physique ; nous permettant ainsi de garantir le niveau maximal de' +
                        '          sécurité sur l\'ensemble des strates de vos systèmes d\'information.<br /><br />' +
                        '          La Citadelle Datacenter fait partie de l\'écosystème BeYs, spécialiste de l\'identité numérique, des flux d\'informations personnelles et du traitement de données sensibles.</p>'
                },
                button: 'Découvrez l\'écosystème BeYs'

            }
        }
    }
};

export default messages;